const NoPage = () => (
    <div className="no-page">
        <div style={{ width: 50 }}>
            <div>
                <h1 className="typed-out short-message">404</h1>
            </div>
        </div>
        <p>Looks like you got a little lost...</p>
        <p>Select one of the tabs above to get back to the action.</p>
    </div>
);

export default NoPage;